import {GameColor} from '../../../../shared/scripts/GameColor'
import {GameFont} from '../../../../shared/scripts/GameFont'
import {ItemCountView} from '../../../../shared/scripts/ui_canvas_engine/ItemCountView'
import {UIGamePlayerInformationDefenderOfColonistView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationDefenderOfColonistView'
import {UIPlayerAdditionalInformationLayer} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'
import {Sprites} from '../../../../shared/scripts/ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../../../shared/scripts/UIGameSpriteHandler'

export class UIMGamePlayerInformationDefenderOfColonistView extends UIGamePlayerInformationDefenderOfColonistView {
    protected createMyDefenderOfColonistView() {
        // design: https://www.figma.com/file/KjHdwcS3tBLtE3DXFKyJQK/Mobile-Game-Master-File?node-id=987%3A253231&mode=dev
        this.createOpponentDefenderOfColonistView()
    }

    protected createOpponentDefenderOfColonistView() {
        const defenderIcon = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_defender)
        const container = this.playerInformation.getContainerForAdditionalPlayerInformation(UIPlayerAdditionalInformationLayer.Layer2)
        const margin = container.width * 0.05

        const defenderOfColonistW = container.width * 0.2
        const defenderOfColonistH = defenderIcon.height * defenderOfColonistW / defenderIcon.width
        const defenderOfColonistX = container.width * 0.7
        const defenderOfColonistY = margin

        const defenderOfColonistCountX = defenderOfColonistX
        const defenderOfColonistCountY = defenderOfColonistY + defenderOfColonistH
        const defenderOfColonistCountW = defenderOfColonistW
        const defenderOfColonistCountH = GameFont.Size.Normal + 2 * margin

        const iconPadding = 0
        this.defenderOfColonistView = new ItemCountView(defenderOfColonistX, defenderOfColonistY, defenderOfColonistW, defenderOfColonistH, container, defenderIcon,
            defenderOfColonistCountX, defenderOfColonistCountY, defenderOfColonistCountW, defenderOfColonistCountH, iconPadding, GameFont.Size.Normal, GameColor.getColor(GameColor.Color.White))
    }
}
